export default {
    namespaced: true,
    state : {
        color:'black'
    },
    getters: {
        getColor(state)
        {
            return state.color
        }
    },
    mutations : {
        switchTheme(state) {
            state.color == 'black' ? state.color = 'white' : state.color = 'black'
        }
    },
    actions : {
        setColor(store)
        {
            store.commit('switchTheme');
        }
    }
}
